<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Resumen final del siniestro:
    {{this.data.siniestro.monedak}}-{{this.data.siniestro.ramok}}-{{this.data.siniestro.sramok}}-{{this.data.siniestro.oficinak}}-{{this.data.siniestro.conseck}}-{{this.data.siniestro.aak}}</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <mat-card-content class="py-0">
    <app-detalle-siniestro-resumen [siniestro]="siniestroResumenSiniestro" [siniestroSeleccionado]="data.siniestro">
    </app-detalle-siniestro-resumen>

    <app-subtitulo-seccion-complemento>
      SERVICIOS
    </app-subtitulo-seccion-complemento>
    <app-detalle-tabla-servicios-siniestro-resumen [datosAsegurado]="serviciosAsegurado"
      [datosTerceros]="serviciosTercero">
    </app-detalle-tabla-servicios-siniestro-resumen>
    <app-subtitulo-seccion-complemento>
      PAGOS & RECUPERACIONES
    </app-subtitulo-seccion-complemento>
    <app-detalle-tabla-pagos-recuperaciones-resumen [datosPagos]="pagos"
      [datosRecuperaciones]="recuperaciones">
    </app-detalle-tabla-pagos-recuperaciones-resumen>
    <app-subtitulo-seccion-complemento>
      OCUPANTES
    </app-subtitulo-seccion-complemento>
    <app-detalle-tabla-ocupantes-resumen [datosAsegurados]="ocupantesAsegurado"
      [datosTerceros]="ocupantesTercero">
    </app-detalle-tabla-ocupantes-resumen>
    <app-subtitulo-seccion-complemento>
      COBERTURAS AFECTADAS
    </app-subtitulo-seccion-complemento>
    <app-detalle-tabla-coberturas-siniestro-resumen [estimaciones]="this.estimacionesSiniestro"
      [listCoberturas]="coberturasSiniestro"
      [datosTerceros]="tercerosSiniestro">
    </app-detalle-tabla-coberturas-siniestro-resumen>

    <app-subtitulo-seccion-complemento>
      ADICIONALES
    </app-subtitulo-seccion-complemento>

    <div class="row" [formGroup]="formularioResumen">
      <div class="col-md-6">
        <!-- Tabla motivos -->
        @if (mostrarTablaMotivos) {
          <mat-checkbox formControlName="sinCosto" (change)="onSinCostoChange($event)">¿Sin
          costo?</mat-checkbox>
          @if (formularioResumen.get('sinCosto').value) {
            <table>
              <mat-radio-group formControlName="motivoCosto">
                @for (fila of filasMotivo; track fila) {
                  <tr>
                    <td>{{ fila.descripl_dato }}</td>
                    <td>
                      <mat-radio-button [value]="fila.valor_dato" [checked]="fila.checked"></mat-radio-button>
                    </td>
                  </tr>
                }
                @if (formularioResumen.get('motivoCosto').hasError('required') && formularioResumen.get('sinCosto').touched) {
                  <mat-error
                    >
                    <small style="font-size: 10.5px;">* Selecciona una opción</small>
                  </mat-error>
                }
              </mat-radio-group>
            </table>
          }
        }
      </div>
      <div class="col-md-6">
        <mat-form-field class="inputFormulario" appearance="outline">
          <mat-label>Observaciones</mat-label>
          <textarea matInput placeholder="Escribe tus observaciones aquí" rows="4"
            formControlName="observaciones">
          </textarea>
          <mat-hint align="end">Máximo 500 caracteres</mat-hint>
          @if (formularioResumen.get('observaciones')?.hasError('required')) {
            <mat-error>
              Este campo es obligatorio
            </mat-error>
          }
        </mat-form-field>
      </div>
      @if (this.data.siniestroDetalle.Siniestro[0].estatus == 4) {
        <div class="col-md-12 d-flex justify-content-end"
          >
          <button type="submit" color="primary" class="mx-1 my-1" mat-raised-button
            (click)="validaGuardaObservaciones(true, false, false)">
            Guardar observaciones
          </button>
        </div>
      }
    </div>

  </mat-card-content>
</mat-dialog-content>
<mat-card-actions class="row mx-0 justify-content-end">
  <div class="col-md-auto col-auto">
    @if (this.data.siniestroDetalle.Siniestro[0].estatus == 4) {
      <button type="submit" color="primary"
        class="mx-1 my-1" mat-raised-button (click)="verificarTerminoSiniestro()">
        Terminar siniestro
      </button>
    }
    <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button (click)="closeDialog('Aceptar')">
      Cerrar
    </button>
  </div>
</mat-card-actions>